export default [
  '$q', 'ResourceService',
  class ProductsService {
    constructor($q, resourceService) {
      this._$q = $q;
      this._resourceService = resourceService;
      this._API_BASE = '/products';
    }

    getDescription (id) {
      if (!id) {
        return this._resourceService.errorPromise('products:getDescription: missing parameters');
      }

      return this._resourceService.get(`${this._API_BASE}/${id}/description`);
    }

    getSizing (id) {
      if (!id) {
        return this._resourceService.errorPromise('products:getSizing: missing parameters');
      }

      return this._resourceService.get(`${this._API_BASE}/${id}/sizing`);
    }

    getSizingAndDescription (id) {
      if (!id) {
        return this._resourceService.errorPromise('products:getSizingAndDescription: missing parameters');
      }

      let sizingRes, descRes,
          sizingDef, descDef;

      sizingDef = this.getSizing(id).then((res) => sizingRes = res);
      descDef = this.getDescription(id).then((res) => descRes = res);

      return this._$q.all([sizingDef, descDef])
               .then(function () {
                 return { sizing: sizingRes, description: descRes.description };
               });
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/products-service.js